var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 12.5714H13.9167C14.2388 12.5714 14.5 12.3156 14.5 12C14.5 11.6844 14.2388 11.4286 13.9167 11.4286H9.25C8.92917 11.4286 8.66667 11.6857 8.66667 12C8.66667 12.3143 8.92917 12.5714 9.25 12.5714ZM4.58333 12.5714H6.91667C7.2375 12.5714 7.5 12.3143 7.5 12C7.5 11.6857 7.2375 11.4286 6.91667 11.4286H4.58333C4.2625 11.4286 4 11.6857 4 12C4 12.3143 4.2625 12.5714 4.58333 12.5714ZM19.1667 0H2.83333C1.54453 0 0.5 1.02321 0.5 2.28571V13.7143C0.5 14.9768 1.54453 16 2.83333 16H19.1667C20.4555 16 21.5 14.9768 21.5 13.7143V2.28571C21.5 1.02321 20.4536 0 19.1667 0ZM20.3333 13.7143C20.3333 14.3443 19.8098 14.8571 19.1667 14.8571H2.83333C2.19021 14.8571 1.66667 14.3443 1.66667 13.7143V8H20.3333V13.7143ZM20.3333 6.85714H1.66667V4.57143H20.3333V6.85714ZM20.3333 3.42857H1.66667V2.28571C1.66667 1.65571 2.19021 1.14286 2.83333 1.14286H19.1667C19.8098 1.14286 20.3333 1.65571 20.3333 2.28571V3.42857Z",
    fill: "#C71717"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.74bb1874dc20175e1c7b1d6fdf9f773e.svg";
export { ForwardRef as ReactComponent };